module.exports = __webpack_public_path__ + "img/121-new-zealand.131d3f29.svg";